import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "service-contracts"
    }}>{`Service contracts`}</h1>
    <p>{`Adobe Commerce and Magento Open Source are modular systems that enable third-party developers to customize and overwrite core parts of the application framework. This flexibility, however, comes at a price. Business logic tends to leak across the layers of the system, which manifests as duplicated and inconsistent code.`}</p>
    <p>{`Merchants might be reluctant to upgrade Adobe Commerce or Magento Open Source because customized extensions that they have purchased might not be compatible with new versions. Also, Adobe and third-party developers can find it difficult to track and report the dependencies that customized extensions have on other extensions.`}</p>
    <p>{`To address these issues, Adobe Commerce and Magento Open Source introduced `}<em parentName="p">{`service contracts`}</em>{`.`}</p>
    <h2 {...{
      "id": "what-is-a-service-contract"
    }}>{`What is a service contract?`}</h2>
    <p>{`A service contract is a set of PHP interfaces that are defined for a module.
A service contract includes `}<a parentName="p" {...{
        "href": "design-patterns.md#data-interfaces"
      }}>{`data interfaces`}</a>{`, which preserve data integrity, and `}<a parentName="p" {...{
        "href": "design-patterns.md#service-interfaces"
      }}>{`service interfaces`}</a>{`, which hide business logic details from service requestors such as controllers, web services, and other modules.`}</p>
    <p>{`If developers define data and service interfaces according to a set of `}<a parentName="p" {...{
        "href": "design-patterns.md"
      }}>{`design patterns`}</a>{`, the result is a well-defined, durable API that other modules and third-party extensions can implement through models and resource models.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "701px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "90.9375%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/commerce/php/static/b2940dab7a42d12a6f8cef4c624aefb7/5530d/msc.webp 320w", "/commerce/php/static/b2940dab7a42d12a6f8cef4c624aefb7/0c8fb/msc.webp 640w", "/commerce/php/static/b2940dab7a42d12a6f8cef4c624aefb7/123bf/msc.webp 701w"],
            "sizes": "(max-width: 701px) 100vw, 701px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/commerce/php/static/b2940dab7a42d12a6f8cef4c624aefb7/8980b/msc.jpg 320w", "/commerce/php/static/b2940dab7a42d12a6f8cef4c624aefb7/56d4e/msc.jpg 640w", "/commerce/php/static/b2940dab7a42d12a6f8cef4c624aefb7/8144e/msc.jpg 701w"],
            "sizes": "(max-width: 701px) 100vw, 701px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/commerce/php/static/b2940dab7a42d12a6f8cef4c624aefb7/8144e/msc.jpg",
            "alt": "Service Contracts",
            "title": "Service Contracts",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "benefits"
    }}>{`Benefits`}</h2>
    <p>{`Service contracts enhance the modularity of Magento. They enable Adobe and third-party developers to report system dependencies through `}<inlineCode parentName="p">{`composer.json`}</inlineCode>{` files and, consequently, guarantee compatibility across versions of Adobe Commerce and Magento Open Source. This compatibility ensures that merchants can easily upgrade Magento.
These contracts ensure a well-defined, durable API that other modules and third-party extensions can implement. Also, these contracts make it easy to `}<a parentName="p" {...{
        "href": "../web-api/services.md"
      }}>{`configure services as web APIs`}</a>{`.`}</p>
    <p>{`Data entities are a side benefit of service contracts.
The database tables that normally support these entities can be complicated.
For example, some attributes might be stored in an EAV table, so a set of MySQL database tables might define a single data entity.
Data entities in a service contract reveal a simpler data model than the data model in an underlying relational database schema.
Eventually, you will be able to use different storage technologies for different data collections. For example, you could use a NoSQL database to replace product tables.`}</p>
    <h2 {...{
      "id": "using-the-api-tag"
    }}>{`Using the @api tag`}</h2>
    <p>{`Backward compatibility can be indicated by the use of `}<inlineCode parentName="p">{`@api`}</inlineCode>{`. For more information, see `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/contributor/guides/code-contributions/backward-compatibility-policy/"
      }}>{`Backward compatibility`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      